module.exports = __webpack_public_path__ + "Occupational-8e85d5623452676f81b8672048b5bb7f.png";